
/**
 * Allowed value range is [0, 255].
 * Because only these numbers can be stored in a single byte.
 */
export enum SeatState {
  Free = 0,
  Sold = 1,
  Taken = 2,
  Reserved = 3,
}
